<template>
<div class="adf-cd">
  <router-view/>
</div>
</template>
